export enum DynamicContentLayout {
  TextContent = 'textContent',
  Photo = 'photo',
  PhotoGallery = 'photoGallery',
  Video = 'video',
  TableWithButton = 'tableWithButton',
  Counter = 'counter',
  NumericList = 'numericList',
}
